import { businessAccessApi } from './businessAccessClient';

/**
 * SAM-814 — cancel a business pass with `PUT /business_access/{id}` `{ business_access_status_id: 6 }`.
 * The server does it in one call: it voids every live charge of the pass (the same path as
 * `POST /business_access/void`) and only then cancels, so there is no gap between the void and the cancel and
 * the admin does not read the payments list. `PATCH /crud/business_access/{id}` with status 6 answers 409
 * `pass_has_payment` for a paid pass.
 *
 * Errors the caller shows through `getApiErrorMessage` (`skipGlobalErrorHandling`: one toast, ours):
 * 409 `void_window_closed` (past the bank cutoff), `CANNOT_VOID_CHECKED_IN`, `payment_in_progress`,
 * 503 `PAYMENT_LEDGER_UNAVAILABLE`, 409 `pass_expired`, 403 (not allowed to cancel / to void). Nothing is
 * cancelled when any of them is answered.
 */
export const cancelBusinessAccessPass = (id: string | number) =>
  businessAccessApi<unknown>({
    url: `/${id}`,
    method: 'PUT',
    data: { business_access_status_id: 6 },
    skipGlobalErrorHandling: true,
  });
